import React from 'react';
import PropTypes from 'prop-types';
import DsBookingStatus from './BookingStatus';
import BookingReference from './BookingReference';

const DsSection = ({
  children,
  title,
  className,
  booking,
  bookingReference,
  headTag,
}) => {
  const CustomTag = headTag;
  return (
          <section className={`${className || ''}`}>
            {title && <div className="flex my-2 justify-between items-center flex-wrap">
              <div>
                <CustomTag className="text-4xl text-primary-500 text-left uppercase font-bold">
                  {title}
                </CustomTag>
                {booking && (
                        <DsBookingStatus status={booking.status} statusDisplay={booking.status_display}/>)}
              </div>
              {bookingReference && (
                      <BookingReference>{bookingReference}</BookingReference>
              )}
            </div>}
            {children && (
                    <div className="mt-4">
                      {children}
                    </div>
            )}

          </section>
  );
};

DsSection.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  headTag: PropTypes.string,
  onClick: PropTypes.func,
};

DsSection.defaultProps = {
  headTag: 'h1',
};

DsSection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default DsSection;
